// extracted by mini-css-extract-plugin
export default {"contained":"divider_contained__F2gRc","full":"divider_full__qDxSv"};